<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle1"><a id="page_iii"></a><a id="contents"></a>CONTENTS</h1>
<p class="toc"><a href="#/04_preface#preface">A Preface Revisited</a></p>
<p class="toc"><a href="#/05_introduction#intro">Introduction: My Journey</a></p>
<p class="toc"><a href="#/06_chapter01#c01">1 Tend Your Own Garden</a></p>
<p class="toc"><span href="#/07_chapter02#c02" title="Link target outside of Sample">2 Stop Focusing on Problems So Their Solutions Can Emerge</span></p>
<p class="toc"><span href="#/08_chapter03#c03" title="Link target outside of Sample">3 Let Go of Outcomes</span></p>
<p class="toc"><span href="#/09_chapter04#c04" title="Link target outside of Sample">4 Change Your Mind</span></p>
<p class="toc"><span href="#/10_chapter05#c05" title="Link target outside of Sample">5 Choose to Act Rather Than React</span></p>
<p class="toc"><span href="#/11_chapter06#c06" title="Link target outside of Sample">6 Give Up Your Judgments</span></p>
<p class="toc"><span href="#/12_chapter07#c07" title="Link target outside of Sample">7 Remember That You Are Not in Control</span></p>
<p class="toc"><span href="#/13_chapter08#c08" title="Link target outside of Sample">8 Discover Your Own Lessons</span></p>
<p class="toc"><span href="#/14_chapter09#c09" title="Link target outside of Sample">9 Do No Harm</span></p>
<p class="toc"><a id="page_iv"></a><span href="#/15_chapter10#c10" title="Link target outside of Sample">10 Quiet Your Mind</span></p>
<p class="toc"><span href="#/16_chapter11#c11" title="Link target outside of Sample">11 Every Encounter Is a Holy Encounter—Respond Accordingly</span></p>
<p class="toc"><span href="#/17_chapter12#c12" title="Link target outside of Sample">12 There Are Two Voices in Your Mind—One Is Always Wrong</span></p>
<p class="toc"><span href="#/18_chapter13#c13" title="Link target outside of Sample">13 Shortcuts for Changing Our Minds and Our Lives: A Summary</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_contents.vue?0e85ec5a